import { app } from '../../../../../app';

app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('company.manage-application.integration-developers.help', {
        url: '/help',
        component: 'companyManageApplicationIntegrationDevelopersHelp',
    });
}



// WEBPACK FOOTER //
// ./src/portal/states/company/manage-application/integration-developers/help/help.state.js